import React from 'react';
import vector from "../../assets/Vector.png"
import avatar from "../../assets/avatar.png"
import logo from "../../assets/vpbank_logo.svg"

const EndCall = ({verified}) => {
    return (
        <div className="w-screen h-screen overflow-auto bg-white relative">
            <img src={vector} className="absolute right-0" alt=""/>
            <div className="relative w-full h-full flex flex-col items-center pt-20">
                <img src={avatar} className="pl-14" alt=""/>
                <img src={logo} className="pt-4" alt=""/>
                {verified && (<div className="text-[#00B74F] mt-4">Đã hoàn tất cuộc gọi</div>)}
                {!verified && (<div className="text-red-600 mt-4 font-bold">Đã dừng cuộc gọi</div>)}
                <div className="mt-4 px-8 text-center">
                    Quý khách vui lòng truy cập lại VPBank NEO để tiếp tục sử dụng dịch vụ.
                </div>
                <a href="https://vpbankneo.page.link/vkyc">
                    <button className="px-8 py-4 shadow-md bg-[#01AD53] text-white mt-8 hover:bg-green-800">
                        Mở VPBank NEO
                    </button>
                </a>
            </div>
        </div>
    )
}

export default EndCall